import { useQuery } from "@tanstack/react-query";
import { DocumentTypeService } from "../../../../services/lookup-data/document-type.service";
import { useCallback } from "react";

export const useDocumentType = () => {
  const { data, ...rest } = useQuery({
    queryKey: ["document-type"],
    queryFn: () => DocumentTypeService.getList(),
  });

  const getDocumentTypeLabel = useCallback(
    (docId: string) => {
      if (!data) return null;
      return data.find((e: any) => e.value === docId)?.label || "";
    },
    [data],
  );

  return { data, ...rest, getDocumentTypeLabel };
};
